import WidgetExternalApplications from './WidgetExternalApplications';

export { default as WidgetExternalApplicationsConfiguration } from './configuration/WidgetExternalApplicationsConfiguration';

export default WidgetExternalApplications;
